import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { DetailEmployeurComponent } from './detail-employeur/detail-employeur.component';
import { EmployeurFormComponent } from './employeur-form/employeur-form.component';
import { ListEmployeurComponent } from './list-employeur/list-employeur.component';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { EmployeurModalAjoutFormComponent } from './modal/prescripteur-modal-ajout-form/employeur-modal-ajout-form.component';

@NgModule({
	declarations: [
		DetailEmployeurComponent,
		EmployeurFormComponent,
		ListEmployeurComponent,
		EmployeurModalAjoutFormComponent
	],
	imports: [SharedModule, GestionDonneesModule]
})
export class EmployeursModule {}
